/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CustomWidgetCustomEvent.vue?vue&type=template&id=da8df788&"
import script from "./CustomWidgetCustomEvent.vue?vue&type=script&lang=js&"
export * from "./CustomWidgetCustomEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports